import React, { useState } from "react";
import { Pressable, View } from "react-native";
import Ionicons from "react-native-vector-icons/Ionicons";
import CCText from "@/Atoms/CCText";
import { Colors } from "@/styles";

export default function FormulaInfo({
  align = "right",
}: {
  align?: "left" | "right";
}) {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const visible = open || hovered;
  return (
    <View
      style={{
        position: "relative",
        zIndex: visible ? 2000 : 1,
        elevation: visible ? 60 : 0,
        overflow: "visible",
      }}>
      <Pressable
        testID="formula-info"
        accessibilityLabel="How club points are calculated"
        onPress={() => setOpen((v) => !v)}
        onHoverIn={() => setHovered(true)}
        onHoverOut={() => setHovered(false)}
        hitSlop={8}>
        <Ionicons name="information-circle-outline" size={16} color={Colors.secondaryAction} />
      </Pressable>
      {visible && (
        <View testID="formula-tooltip" style={{ position: "absolute", top: 22,
          ...(align === "left" ? { left: 0 } : { right: 0 }),
          zIndex: 2000, elevation: 60,
          backgroundColor: Colors.white, borderRadius: 10, padding: 10,
          borderWidth: 1, borderColor: "#EEE7D6", width: 240,
          // @ts-ignore web-only
          boxShadow: "0 4px 14px rgba(0,0,0,0.12)" }}>
          <CCText fontSize={12} color={Colors.fontRegular} fontWeight="400">
            Points = Puzzle Solved ×2 + Game Win ×10
          </CCText>
        </View>
      )}
    </View>
  );
}
